module.exports = __webpack_public_path__ + "img/inactive-3.75eee078.svg";